<template>
  <div>
    <sj-button style="margin:10px" @click="click1">基础上传</sj-button>
    <sj-button style="margin:10px" @click="click2">只允许图片</sj-button>
  </div>
</template>

<script>
export default {
  methods: {
    click1() {
      this.$SjUpload().then(file => {
        alert(file);
      });
    },
    click2() {
      this.$SjUpload({
        accept: "image/*"
      }).then(file => {
        alert(file);
      });
    }
  }
};
</script>

<style scoped lang="less"></style>
